export default {
  isEmpty(value) {
    if (value === undefined || value === null) {
      return true;
    }
    if (value instanceof Set || value instanceof Map) {
      return value.size === 0;
    }

    switch (typeof value) {
      case "object":
        return Object.keys(value).length === 0;
      case "string":
        return value.length === 0;
    }
    return true;
  },

  setEnterPoint(params) {
    if (params === "https://dev.teacher.open-college.ru:8080") {
      return {
        name: "local",
        avatarUrl: "https://college.instudy.online/img/mgok/avatar",
        url: "https://teacher.open-college.ru",
        logoBig: "logo.png",
        logoSmall: "logo.png",
        downloadLink: "https://college.instudy.online",
      };
    } else if (
      params === "http://teacher.open-college.ru" ||
      params === "https://teacher.open-college.ru"
    ) {
      return {
        name: "mgok",
        avatarUrl: "https://college.instudy.online/img/mgok/avatar",
        url: "https://teacher.open-college.ru",
        logoBig: "logo.png",
        logoSmall: "logo.png",
        downloadLink: "https://college.instudy.online",
      };
    } else if (params === "http://93.188.124.162:30680") {
      return {
        name: "test",
        url: "http://93.188.124.162:30680",
        logoBig: "logo.png",
        logoSmall: "logo.png",
        downloadLink: "https://rpanel.inpsycho.ru",
      };
    } else if (params === "https://teacher.mveu.ru") {
      return {
        name: "mveu",
        url: "https://teacher.mveu.ru",
        logoBig: "logo.png",
        logoSmall: "logo.png",
        downloadLink: "",
      };
    }
  },
  timeCorrector(value) {
    return value ? value.split(" ")[1] : "";
  },
  dateCorrector(value) {
    if (value) {
      let date = new Date(value);
      if (date != "Invalid Date") {
        let month =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1;
        let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return (
          day +
          "." +
          month +
          "." +
          String(date.getFullYear())[2] +
          String(date.getFullYear())[3]
        );
      } else {
        return "";
      }
    } else {
      return "";
    }
  },

  getNameDay(value) {
    var date = new Date(value);
    var options = { weekday: "long" };
    return date.toLocaleString("ru", options);
  },

  copyText(text) {
    const tmpTextField = document.createElement("textarea");
    tmpTextField.textContent = text;
    tmpTextField.setAttribute("style", "position:absolute; right:200%;");
    document.body.appendChild(tmpTextField);
    tmpTextField.select();
    tmpTextField.setSelectionRange(0, 99999); /* For mobile devices*/
    document.execCommand("copy");
    tmpTextField.remove();
  },
};
